// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileCharts_wrapper__-5U2G"};